import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.config}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/configuration/acceptedLanguages`;

export interface SetSellerConfigurationAcceptedLanguagesCommandArgs {
  sellerId: string;
  acceptedLanguages: string[];
}

export default async function setSellerConfigurationAcceptedLanguagesCommand(
  payload: SetSellerConfigurationAcceptedLanguagesCommandArgs,
): Promise<BaseBackResponse | BackResponseFailure> {
  try {
    const { sellerId, acceptedLanguages } = payload;
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId);

    return await apiCall<BaseBackResponse>(url, {
      method: SUPPORTED_METHODS.POST,
      json: { acceptedLanguages },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
